import { i18n } from "@/plugins/i18n";
import { Validator } from "vee-validate";
import { Component, Inject, Vue } from "vue-property-decorator";
import Template from "./createClientModal.template.vue";

@Component({
  mixins: [Template]
})
export default class CreateClientModalComponent extends Vue {
  @Inject() public $validator!: Validator;
  public model: { name: null | string } = { name: null };
  public isFormValid = false;

  public async submitForm() {
    if (this.isFormValid) {
      this.$emit("resolve", this.model.name);
    }
  }

  public errorMessage() {
    if (this.$validator.errors.first("name")) {
      switch (
        this.$validator.errors
          .first("name")
          .split(". ")
          .reverse()[0]
      ) {
        case "field is required.":
          return i18n.t("client_integrations.name_required");
        default:
          return i18n.t("client_integrations.validation_message");
      }
    }
  }
}
